// Main configuration file for the application
import { getEnvironmentConfig } from "./environment";

const envConfig = getEnvironmentConfig();

export const config = {
  // Company Information
  company: {
    name: "مطعم الحرم",
    nameEn: "Matjar Al Haram",
    description: "متجر الحرم - أفضل المنتجات والخدمات",
    descriptionEn: "Al Haram Store - Best Products and Services",
    logo: "/images/logo-2.svg",
  },

  // Contact Information
  contact: {
    email: envConfig.contact?.email || "info@alhrmstore.com",
    phone: envConfig.contact?.phone || "+966 59 240 6070",
    mobile:
      envConfig.contact?.mobile ||
      envConfig.contact?.phone ||
      "+966 59 240 6070",
    whatsapp:
      envConfig.contact?.whatsapp ||
      envConfig.contact?.phone ||
      "+966 59 240 6070",
    address: {
      ar: "شارع القليلة - حي الشرائع - مكة المكرمة - المملكة العربية السعودية",
      en: "Al-Qalila Street - Al-Shara'i District - Makkah - Saudi Arabia",
    },
    workingHours: {
      ar: "السبت - الخميس: 9:00 ص - 12:00 م",
      en: "Saturday - Thursday: 9:00 AM - 12:00 PM",
    },
  },

  // Social Media Links
  socialMedia: {
    // facebook: {
    //   url:
    //     envConfig.socialMedia?.facebook?.url ||
    //     "https://facebook.com/alhrmstore",
    //   icon: "ti-facebook",
    //   enabled: envConfig.socialMedia?.facebook?.enabled !== false,
    // },
    twitter: {
      url:
        envConfig.socialMedia?.twitter?.url ||
        "https://x.com/alhrmstore?s=11&t=rhVukpy8RG8jtXYpkZLOtg",
      icon: "ti-twitter-alt",
      enabled: envConfig.socialMedia?.twitter?.enabled !== false,
    },
    instagram: {
      url:
        envConfig.socialMedia?.instagram?.url ||
        "https://www.instagram.com/alhrmstore?igsh=dHZ2cmcwMmo1OTl0",
      icon: "ti-instagram",
      enabled: envConfig.socialMedia?.instagram?.enabled !== false,
    },
    // linkedin: {
    //   url: "https://linkedin.com/company/alhrmstore",
    //   icon: "ti-linkedin",
    //   enabled: false,
    // },
    // youtube: {
    //   url: "https://youtube.com/@alhrmstore",
    //   icon: "ti-youtube",
    //   enabled: false,
    // },
    // tiktok: {
    //   url: "https://tiktok.com/@alhrmstore",
    //   icon: "ti-tiktok",
    //   enabled: false,
    // },
  },

  // API Configuration
  api: {
    baseURL:
      envConfig.api?.baseURL ||
      process.env.REACT_APP_API_URL ||
      "http://localhost:3001/api",
    timeout: envConfig.api?.timeout || 10000,
    retryAttempts: 3,
  },

  // App Configuration
  app: {
    defaultLanguage: "ar",
    supportedLanguages: ["ar", "en"],
    theme: {
      primaryColor: "#ff6b35",
      secondaryColor: "#2c3e50",
      accentColor: "#f39c12",
    },
    features: {
      newsletter: true,
      socialLogin: true,
      multiLanguage: true,
      darkMode: false,
    },
  },

  // SEO Configuration
  seo: {
    title: "مطعم الحرم - Matjar Al Haram",
    description: "متجر الحرم - أفضل المنتجات والخدمات في مكة المكرمة",
    keywords: [
      "مطعم الحرم",
      "Matjar Al Haram",
      "مكة المكرمة",
      "Makkah",
      "متجر",
      "store",
    ],
    ogImage: "/images/logo-2.svg",
    twitterCard: "summary_large_image",
  },

  // Payment Configuration
  payment: {
    moyasar: {
      publishableKey: process.env.REACT_APP_MOYASAR_PUBLISHABLE_KEY,
      enabled: true,
    },
    methods: ["credit_card", "apple_pay", "stc_pay"],
  },

  // Shipping Configuration
  shipping: {
    freeShippingThreshold: 200, // SAR
    standardShippingCost: 25, // SAR
    expressShippingCost: 50, // SAR
    estimatedDeliveryDays: {
      standard: "3-5 أيام",
      express: "1-2 أيام",
    },
  },
};

// Helper function to get social media links that are enabled
export const getEnabledSocialMedia = () => {
  return Object.entries(config.socialMedia)
    .filter(([key, value]) => value.enabled)
    .map(([key, value]) => ({ platform: key, ...value }));
};

// Helper function to get contact info by language
export const getContactInfo = (language = "ar") => {
  return {
    ...config.contact,
    address: config.contact.address[language] || config.contact.address.ar,
    workingHours:
      config.contact.workingHours[language] || config.contact.workingHours.ar,
  };
};

export default config;
